import { render, staticRenderFns } from "./CadastrosCidadaos.vue?vue&type=template&id=8e5c7eda"
import script from "./CadastrosCidadaos.vue?vue&type=script&lang=js"
export * from "./CadastrosCidadaos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports